<mce-page-with-navigation>
    <div>
        <h1>Settings</h1>
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>Appearance</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p class="my-4" id="theme-description">
                    Choose how the app looks. Changes apply immediately and are saved in this browser.
                </p>
                <mat-form-field appearance="outline" class="w-full sm:max-w-xs">
                    <mat-label>Colour mode</mat-label>
                    <mat-select [formField]="settingsForm.theme"
                                (selectionChange)="setTheme($event.value)"
                                aria-describedby="theme-description">
                        <mat-option value="light">Light</mat-option>
                        <mat-option value="dark">Dark</mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="mt-4">
            <mat-card-header>
                <mat-card-title>Shared billing</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                @switch (sharedBillingMode()) {
                    @case ('owner') {
                    <p class="my-4">
                        Invite people to use myCableEngineering with their usage billed to your account.
                        Manage their access and review shared usage.
                    </p>
                    }
                    @case ('member') {
                    <p class="my-4">
                        Your usage is billed to a shared billing owner's account.
                        View your membership and owner details on the Account page.
                    </p>
                    }
                    @case ('locked') {
                    <div class="flex flex-col items-center gap-2 py-4 text-center">
                        <mat-icon>lock</mat-icon>
                        <p class="m-0 font-medium">Shared billing is available on Pro.</p>
                        <p class="m-0">Invite people to use myCableEngineering with their usage billed to your account.</p>
                    </div>
                    }
                }
            </mat-card-content>
            <mat-card-actions align="end" class="flex flex-wrap gap-4">
                @switch (sharedBillingMode()) {
                    @case ('owner') {
                    <a matButton routerLink="/settings/shared-billing/users"><mat-icon>group</mat-icon>Manage Users</a>
                    <button matButton type="button" (click)="viewSharedBillingUsage()"><mat-icon>table_chart</mat-icon>View Usage</button>
                    }
                    @case ('member') {
                    <a matButton routerLink="/account"><mat-icon>group</mat-icon>View shared billing</a>
                    }
                    @case ('locked') {
                    <a matButton routerLink="/account"><mat-icon>credit_card</mat-icon>Plan &amp; Billing</a>
                    }
                }
            </mat-card-actions>
        </mat-card>
    </div>
</mce-page-with-navigation>
